<div class="q-question" [class.q-question--invalid]="invalid" [class.q-question--first]="first">
  <div class="q-qtext">
    {{ qText() }}<span class="q-req" *ngIf="q.required"> *</span>
  </div>

  <!-- text -->
  <textarea *ngIf="q.questionType==='text'" class="q-input q-textarea" rows="2"
            [(ngModel)]="answers[key]" (change)="committed.emit()" [attr.dir]="dirValue"></textarea>

  <!-- number -->
  <input *ngIf="q.questionType==='number'" class="q-input" type="number"
         [(ngModel)]="answers[key]" (change)="committed.emit()" />

  <!-- date -->
  <input *ngIf="q.questionType==='date'" class="q-input" type="date"
         [attr.min]="dateBound('dateMin') || null" [attr.max]="dateBound('dateMax') || null"
         [(ngModel)]="answers[key]" (change)="committed.emit()" />

  <!-- boolean -->
  <div *ngIf="q.questionType==='boolean'" class="q-choices">
    <label class="q-choice">
      <input type="radio" [name]="'q'+key" value="yes" [(ngModel)]="answers[key]" (change)="committed.emit()" />
      <span>{{ 'questionnaire.Yes' | translate }}</span>
    </label>
    <label class="q-choice">
      <input type="radio" [name]="'q'+key" value="no" [(ngModel)]="answers[key]" (change)="committed.emit()" />
      <span>{{ 'questionnaire.No' | translate }}</span>
    </label>
  </div>

  <!-- radio -->
  <div *ngIf="q.questionType==='radio'" class="q-choices">
    <label class="q-choice" *ngFor="let o of q.options">
      <input type="radio" [name]="'q'+key" [value]="o.optionText" [(ngModel)]="answers[key]" (change)="committed.emit()" />
      <span>{{ oText(o) }}</span>
    </label>
    <input *ngIf="selectedOptionExtraFieldType()"
           class="q-input q-other-text"
           [type]="selectedOptionExtraFieldType()==='number' ? 'number' : 'text'"
           [attr.inputmode]="selectedOptionExtraFieldType()==='number' ? 'numeric' : null"
           [attr.dir]="selectedOptionExtraFieldType()==='number' ? 'ltr' : dirValue"
           [ngModel]="otherTextValue(key)" (ngModelChange)="setOtherText(key, $event)"
           [placeholder]="'questionnaire.Please specify' | translate" />
  </div>

  <!-- select -->
  <select *ngIf="q.questionType==='select'" class="q-input" [(ngModel)]="answers[key]" (change)="committed.emit()">
    <option value="">{{ 'questionnaire.Choose' | translate }}</option>
    <option *ngFor="let o of q.options" [value]="o.optionText">{{ oText(o) }}</option>
  </select>
  <input *ngIf="q.questionType==='select' && selectedOptionExtraFieldType()"
         class="q-input q-other-text"
         [type]="selectedOptionExtraFieldType()==='number' ? 'number' : 'text'"
         [attr.inputmode]="selectedOptionExtraFieldType()==='number' ? 'numeric' : null"
         [attr.dir]="selectedOptionExtraFieldType()==='number' ? 'ltr' : dirValue"
         [ngModel]="otherTextValue(key)" (ngModelChange)="setOtherText(key, $event)"
         [placeholder]="'questionnaire.Please specify' | translate" />

  <!-- checkbox -->
  <div *ngIf="q.questionType==='checkbox'" class="q-choices">
    <ng-container *ngFor="let o of q.options">
      <label class="q-choice">
        <input type="checkbox"
               [checked]="isChecked(o.optionText)"
               (change)="toggleCheckbox(o.optionText, $any($event.target).checked); committed.emit()" />
        <span>{{ oText(o) }}</span>
      </label>
      <input *ngIf="optionHasExtraField(o) && isChecked(o.optionText)"
             class="q-input q-other-text"
             [type]="extraFieldType(o)==='number' ? 'number' : 'text'"
             [attr.inputmode]="extraFieldType(o)==='number' ? 'numeric' : null"
             [attr.dir]="extraFieldType(o)==='number' ? 'ltr' : dirValue"
             [ngModel]="otherTextValue(checkboxOtherKey(o.optionText))"
             (ngModelChange)="setOtherText(checkboxOtherKey(o.optionText), $event)"
             [placeholder]="'questionnaire.Please specify' | translate" />
    </ng-container>
  </div>

  <!-- signature -->
  <app-signature-pad *ngIf="q.questionType==='signature'"
                     (changed)="setSignature($event); committed.emit()"></app-signature-pad>
</div>
